module.exports = __webpack_public_path__ + "static/media/qr-frame.0906adbb.png";